import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Landing from "./pages/Landing";
import PillarRoute from "./pages/PillarRoute";
import TreatmentRoute from "./pages/TreatmentRoute";
import Admin from "./pages/Admin";
import { Nav } from "./components/medskin/Nav";
import { Footer } from "./components/medskin/Footer";
import { ScrollToTop } from "./components/medskin/ScrollToTop";

function Chrome({ children }) {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");
  return (
    <>
      {!isAdmin && <Nav />}
      {children}
      {!isAdmin && <Footer />}
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Chrome>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/hudutfordringer/:slug" element={<PillarRoute />} />
            <Route path="/behandlinger/:slug" element={<TreatmentRoute />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </Chrome>
      </BrowserRouter>
    </div>
  );
}

export default App;
